import React, { useState } from 'react';
import '../styles/SelectedComps.css';
import { Arrow, ChevronWide, Copy, House, MapBubble, TickHeavy } from '../assets/icons';
import { colour } from '../styles/GlobalStyles';
import { Button, Dropdown, ExitScreen, IconButton, SmallCompCard } from './';
import { HugeiconsIcon } from '@hugeicons/react';
import { Download04Icon } from '@hugeicons/core-free-icons';
import { recordEvent, setSelectedPropertyReportTransaction, setSelectedPropertyTransaction } from '../functions';

function SelectedComps(props) {
    const allSelectedComps = props.allSelectedComps;
    const setAllSelectedComps = props.setAllSelectedComps;
    const fullSelectedComps = props.fullSelectedComps;
    const toggleSelectedComp = props.toggleSelectedComp;
    const expanded = props.expanded;
    const setExpanded = props.setExpanded;
    const showScrollableImages = props.showScrollableImages;
    const openDetailedView = props.openDetailedView;
    const downloadProperties = props.downloadProperties;
    const shareLink = props.shareLink;
    const downloadLoading = props.downloadLoading;
    const selectedPanel = props.selectedPanel;
    const setSelectedPanel = props.setSelectedPanel;
    const compTypeDropdownOpen = props.compTypeDropdownOpen;
    const setCompTypeDropdownOpen = props.setCompTypeDropdownOpen;
    const closeDropdowns = props.closeDropdowns;
    const companyId = props.companyId;
    const property = props.property;
    const linkCopied = props.linkCopied;
    const linkCopiedError = props.linkCopiedError;
    const readOnly = props.readOnly;
    const compTypeLegend = props.compTypeLegend;
    const isLoaded = props.isLoaded;
    const bestComps = props.bestComps;
    const innerWidth = props.innerWidth;
    // const getARV = props.getARV;
    const arvLoading = props.arvLoading;
    // const arvEstimate = props.arvEstimate;
    const mobileSelectedCompsBody = props.mobileSelectedCompsBody;
    // const autoKeepComps = props.autoKeepComps;
    // const compsChanged = props.compsChanged;
    // const setRegenerateARVErrorModal = props.setRegenerateARVErrorModal;
    // const actionRequired = props.actionRequired;
    const bodyRef = props.bodyRef;
    const bodyWidth = bodyRef.current?.offsetWidth;
    const chatbotCollapsed = props.chatbotCollapsed;
    const arvComps = allSelectedComps.filter(e => e.type === "arv");
    const asIsComps = allSelectedComps.filter(e => e.type === "as-is");
    const dropdownOpenObject = compTypeDropdownOpen === null ? [] : allSelectedComps.filter(e => e.zpid === compTypeDropdownOpen)[0];
    const [downloadTooltip, setDownloadTooltip] = useState(false);

    const toggleExpanded = () => {
        setExpanded(!expanded);

        if ( !expanded === false ) {
            setCompTypeDropdownOpen(null);
            recordEvent("close_wizard", {});
        }
        else {
            recordEvent("open_wizard", {});
            if ( mobileSelectedCompsBody.current !== null ) {
                setTimeout(() => {
                    mobileSelectedCompsBody.current.scrollTop = 0;
                }, 50);
            }
        }
    };

    const removeComp = (item) => {
        toggleSelectedComp(item);
    };

    const options = [
        {
            label: `All (${allSelectedComps.length})`,
            value: "all",
            selected: selectedPanel === "all" ? true : false,
            rangeTitle: "Range"
        },
        {
            label: `ARV (${arvComps.length})`,
            value: "arv",
            selected: selectedPanel === "arv" ? true : false,
            rangeTitle: "Range"
        },
        {
            label: `As-is (${asIsComps.length})`,
            value: "as-is",
            selected: selectedPanel === "as-is" ? true : false,
            rangeTitle: "Range"
        },
        // {
        //     label: `Novation (${novationComps.length})`,
        //     value: "novation",
        //     selected: selectedPanel === "novation" ? true : false,
        //     rangeTitle: "Range"
        // }
    ];

    const onChangeSelected = (value) => {
        setSelectedPanel(value);
    };

    const toggleCompTypeDropdown = (zpid) => {
        setCompTypeDropdownOpen(compTypeDropdownOpen === zpid ? null : zpid);
    };

    const changeCompStatus = (item, index) => {
        const value = item.value;
        const zpid = dropdownOpenObject.zpid;

        const cloneAllComps = [...allSelectedComps];
        const compIndex = cloneAllComps.findIndex(e => e.zpid === zpid);
        cloneAllComps[compIndex].type = value;
        setAllSelectedComps(cloneAllComps);
        setCompTypeDropdownOpen(null);

        if ( companyId !== null ) {
            const colRef = "companies";
            const docRef = companyId;
            const subColRef = "properties";
            const subDocRef = property.uniqueIds.propertyId;
            setSelectedPropertyTransaction(colRef, docRef, subColRef, subDocRef, cloneAllComps);
            setSelectedPropertyReportTransaction("reports", docRef, subColRef, subDocRef, cloneAllComps);
        }

        const remainingCompsInSection = cloneAllComps.filter(e => e.type === selectedPanel).length;
        if ( remainingCompsInSection === 0 ) {
            setSelectedPanel("all");
        }
        recordEvent("change_comp_status", {
            zpid: zpid,
            value: value
        });
    };

    const compTypeOptions = [
        {
            label: "ARV",
            value: "arv",
            selected: dropdownOpenObject.type === "arv" ? true : false
        },
        {
            label: "As-is",
            value: "as-is",
            selected: dropdownOpenObject.type === "as-is" ? true : false
        },
        // {
        //     label: "Novation",
        //     value: "novation",
        //     selected: dropdownOpenObject.type === "novation" ? true : false
        // }
    ];

    const getLabel = (item) => {
        const getType = allSelectedComps.filter(e => e.zpid === item.uniqueIds.zillowId)[0].type;
        if ( getType === null ) {
            return "Unspecified";
        }
        else {
            const getTypeObject = compTypeOptions.filter(e => e.value === getType)[0];
            return getTypeObject.label;
        }
    };

    const checkZPIDCategory = (zpid) => {
        const compIndex = allSelectedComps.findIndex(e => e.zpid === zpid);
        const compType = allSelectedComps[compIndex].type;
        if (selectedPanel === "all") {
            return true;
        }
        else {
            return compType === selectedPanel;
        }
    };

    const getCompTypeObject = (item) => {
        const zpid = item.uniqueIds.zillowId;
        const compIndex = allSelectedComps.findIndex(e => e.zpid === zpid);
        if ( compIndex === -1 ) {
            return null;
        }
        const compType = allSelectedComps[compIndex].type;
        const compTypeObject = compTypeLegend.filter(e => e.value === compType)[0];
        return compTypeObject;
    }

    return (
        <div 
            className={"selected-comps-outer-container bg-colour-white " + (chatbotCollapsed === true ? "selected-comps-chatbot-collapsed" : "selected-comps-chatbot-expanded")}
            style={{
                "--body-width": bodyWidth ? `${bodyWidth}px` : "auto"
            }}
        >
            {
                compTypeDropdownOpen !== null &&
                <ExitScreen
                    clickScreen={() => closeDropdowns()}
                />
            }
            <div className="selected-comps-inner-container mobile-none">
                <div className={"selected-comps-top-container " + (expanded === true ? "selected-comps-expanded-inner-container" : "selected-comps-unexpanded-inner-container")}>
                    <div className="selected-comps-top-inner-container">
                        <div className="selected-comps-top-left-container">
                            <div className="selected-comps-top-left-title-container">
                                <span className="heading-small-regular colour-primary">
                                    {allSelectedComps.length} selected comps
                                </span>
                                <div className="desktop-none">
                                    <IconButton
                                        size="large"
                                        icon={<Arrow fill={colour.gray06} className="selected-comps-mobile-arrow reverse" />}
                                        disabled={false}
                                        clickFunc={() => toggleExpanded()}
                                        standardIcon={false}
                                        background={true}
                                        bgType={"white"}
                                        contextTooltip={false}
                                        contextTooltipBG={null}
                                        contextTooltipText={null}
                                        customClass={null}
                                    />
                                </div>
                            </div>
                            {
                                arvLoading === false &&
                                <div className={"selected-comps-count-container " + (expanded === false ? "view-none" : "")}>
                                    {
                                        options.map((item, index) =>
                                            <div 
                                                className="selected-comps-count-element"
                                                key={index}
                                                onClick={() => item.label.includes("(0)") ? null : onChangeSelected(item.value)}
                                            >
                                                <span className={(innerWidth < 400 ? "label-regular " : "body-regular ") + (item.selected === true ? "colour-primary underline " : "colour-secondary ") + (item.label.includes("(0)") ? "" : "cursor-pointer")}>
                                                    {item.label}
                                                </span>
                                            </div>
                                        )
                                    }
                                </div>
                            }
                        </div>
                        <div className="selected-comps-top-right-container">
                            {/* {
                                getARV !== null && readOnly === false && (selectedPanel === "all" || selectedPanel === "arv") ?
                                <div className={"selected-comps-get-arv-container " + (arvLoading === true ? "selected-comps-get-arv-container-loading" : "")}>
                                    <Button
                                        buttonType="primary-button"
                                        size="large"
                                        text={"Regenerate ARV"}
                                        cta={() => getARV()}
                                        disabled={arvComps.length < 2 ? true : actionRequired === true ? true : arvEstimate === null ? false : !compsChanged}
                                        leftIcon={arvLoading === true ? null : <Wand fill={colour.gray00} className="selected-comps-wand" />}
                                        leftIconClass=""
                                        rightIcon={null}
                                        rightIconClass=""
                                        alt=""
                                        standardIcon={false}
                                        badge={false}
                                        badgeVal={null}
                                        badgeBG={null}
                                        buttonRef={null}
                                        spinner={arvLoading}
                                        disabledAction={openARVErrorModal}
                                    />
                                </div>
                                :
                                null
                            } */}
                            {
                                allSelectedComps.length > 0 && companyId !== null && readOnly === false &&
                                <div className="selected-comps-share-container">
                                    <Button
                                        buttonType="secondary-button"
                                        size="large"
                                        text={linkCopied === true ? "Link copied" : "Share link"}
                                        cta={() => shareLink()}
                                        disabled={false}
                                        leftIcon={linkCopied === true ? <TickHeavy fill={colour.gray06} className="" /> : <Copy fill={colour.gray06} className="" />}
                                        leftIconClass=""
                                        rightIcon={null}
                                        rightIconClass=""
                                        alt=""
                                        standardIcon={false}
                                        badge={false}
                                        badgeVal={null}
                                        badgeBG={null}
                                        buttonRef={null}
                                        spinner={false}
                                    />
                                    {
                                        linkCopiedError === true &&
                                        <span className="body-regular colour-error">
                                            There was an error copying the link
                                        </span>
                                    }
                                </div>
                            }
                            {
                                allSelectedComps.length > 0 &&
                                <div 
                                    className="selected-comps-download-container relative-container"
                                    onMouseEnter={() => setDownloadTooltip(true)}
                                    onMouseLeave={() => setDownloadTooltip(false)}
                                >
                                    <IconButton
                                        size="medium"
                                        icon={<HugeiconsIcon icon={Download04Icon} color={colour.gray06} size={16} />}
                                        disabled={downloadLoading}
                                        clickFunc={() => downloadProperties()}
                                        standardIcon={false}
                                        background={true}
                                        bgType={"white"}
                                        contextTooltip={downloadTooltip}
                                        contextTooltipBG={"dark"}
                                        contextTooltipText={"Download CSV"}
                                        customClass={null}
                                    />
                                </div>
                            }
                            <div 
                                className="selected-comps-expand-container text-button"
                                onClick={() => toggleExpanded()}
                            >
                                <span className="body-regular colour-primary">
                                    {
                                        expanded ? "Collapse" : "Expand"
                                    }
                                </span>
                                <ChevronWide
                                    fill={colour.gray07}
                                    className={expanded === false ? "reverse" : "" }
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"selected-comps-bottom-container " + (expanded === true ? "selected-comps-bottom-container-expanded" : "selected-comps-bottom-container-unexpanded")}>
                    {
                        fullSelectedComps.length > 0 && expanded === true &&
                        <div className="selected-comps-card-container">
                            {
                                fullSelectedComps.map((item, index) =>
                                    (selectedPanel === "all" || checkZPIDCategory(item.uniqueIds.zillowId) === true) &&
                                    <div 
                                        className="selected-comps-card-element"
                                        key={index}
                                    >
                                        <SmallCompCard
                                            property={item}
                                            closeCompCard={null}
                                            selected={true}
                                            addSelectedComp={readOnly === true ? null : removeComp}
                                            overlay={true}
                                            showScrollableImages={showScrollableImages}
                                            slideshow={false}
                                            openDetailedView={openDetailedView}
                                            expanded={expanded}
                                            subjectPropertyObject={property}
                                            isLoaded={isLoaded}
                                            bestComp={bestComps.findIndex(e => e.uniqueIds.zillowId === item.uniqueIds.zillowId) !== -1 ? true : false}
                                        />
                                        {
                                            readOnly === false ?
                                            <Dropdown
                                                open={compTypeDropdownOpen === item.uniqueIds.zillowId ? true : false}
                                                icon={null}
                                                label={getLabel(item)}
                                                disabled={false}
                                                options={compTypeOptions}
                                                multiselect={false}
                                                toggleDropdown={() => expanded === false ? null : toggleCompTypeDropdown(item.uniqueIds.zillowId)}
                                                cta={(item, index) => expanded === false ? null : changeCompStatus(item, index)}
                                                sidealign={"left"}
                                                topalign={"top"}
                                                indexSelect={false}
                                                selectedIndex={null}
                                            />
                                            :
                                            getCompTypeObject(item) !== null ?
                                            <div className="run-comps-best-comps-title-container">
                                                <div className="relative-container">
                                                    <MapBubble
                                                        className=""
                                                        fill={getCompTypeObject(item).fill}
                                                        stroke={getCompTypeObject(item).stroke}
                                                        strokeWidth="0.5"
                                                    />
                                                    <House
                                                        fill={getCompTypeObject(item).house}
                                                        className="all-comps-map-house-icon"
                                                    />
                                                </div>
                                                <span className="body-bold colour-primary">
                                                    {getCompTypeObject(item).label.slice(0, -1)}
                                                </span>
                                            </div>
                                            :
                                            null
                                        }
                                    </div>
                                )
                            }
                        </div>
                    }
                </div>
            </div>
            {/* <div className="selected-comps-inner-container desktop-none">
                {
                    readOnly === false &&
                    <div className="selected-comps-mobile-right-container">
                        {
                            getARV !== null && readOnly === false ?
                            <Button
                                buttonType="primary-button"
                                size="large"
                                text={"Regenerate ARV"}
                                cta={() => getARV()}
                                disabled={arvComps.length < 2 ? true : actionRequired === true ? true : arvEstimate === null ? false : !compsChanged}
                                leftIcon={arvLoading === true ? null : <Wand fill={colour.gray00} className="selected-comps-wand" />}
                                leftIconClass=""
                                rightIcon={null}
                                rightIconClass=""
                                alt=""
                                standardIcon={false}
                                badge={false}
                                badgeVal={null}
                                badgeBG={null}
                                buttonRef={null}
                                spinner={arvLoading}
                                disabledAction={openARVErrorModal}
                            />
                            :
                            getARV !== null && arvComps.length < 2 && readOnly === false && autoKeepComps !== null ?
                            <Button
                                buttonType="primary-button"
                                size="large"
                                text={"Auto-keep comps"}
                                cta={() => autoKeepComps()}
                                disabled={false}
                                leftIcon={arvLoading === true ? null : <Wand fill={colour.gray00} className="selected-comps-wand" />}
                                leftIconClass=""
                                rightIcon={null}
                                rightIconClass=""
                                alt=""
                                standardIcon={false}
                                badge={false}
                                badgeVal={null}
                                badgeBG={null}
                                buttonRef={null}
                                spinner={arvLoading}
                            />
                            :
                            null
                        }
                    </div>
                }
            </div> */}
        </div>
    )
};

export default SelectedComps;